import { render, staticRenderFns } from "./afterSalesDetall.vue?vue&type=template&id=ba1b9d2e&scoped=true&"
import script from "./afterSalesDetall.vue?vue&type=script&lang=js&"
export * from "./afterSalesDetall.vue?vue&type=script&lang=js&"
import style0 from "./afterSalesDetall.vue?vue&type=style&index=0&id=ba1b9d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1b9d2e",
  null
  
)

export default component.exports